import { createContext, useState } from "react";

export const SupportContext = createContext();

const intialSupportFilters = {
    fullName: "",
    dateOfBirth: "",
    residentLocation: "",
    status: "",
    createdAt: "",
    updatedAt: "",
    _phoneNumber: "",
    startDate:"",
    endDate:""
  }

export const SupportProvider = ({ children }) => {
  
  const [supportSearchTerm, setSupportSearchTerm] = useState("");
  const [supportFilters, setSupportFilters] = useState(intialSupportFilters);
  const [ContextCurrentPage, contextSetCurrentPage] = useState(1);
  const [ContextTotalPages, contextSetTotalPages] = useState(0);
  const [Contextlimit] = useState(5);
  const [ContextReload, ContextSetReload] = useState(false);

  return (
    <SupportContext.Provider
      value={{
        supportSearchTerm,
        setSupportSearchTerm,
        setSupportFilters,
        supportFilters,
        intialSupportFilters,
        ContextCurrentPage,
        contextSetCurrentPage,
        ContextTotalPages,
        contextSetTotalPages,
        Contextlimit,
        ContextReload,
        ContextSetReload,
      }}
    >
      {children}
    </SupportContext.Provider>
  );
};
